import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { getExpireSoonTitle } from '../../utils/getExpireSoonTitle';

type BaseProps = {
  showArchived?: boolean;
  showExpired?: boolean;
};

type ExpireSoonFalse = {
  showExpireSoon?: false;
  segmentDaysRemaining?: never;
};

type ExpireSoonTrue = {
  showExpireSoon: true;
  segmentDaysRemaining: number;
};

export type SegmentAlertProps = BaseProps & (ExpireSoonFalse | ExpireSoonTrue);

export const SegmentAlert = ({
  showArchived,
  showExpired,
  showExpireSoon,
  segmentDaysRemaining,
}: SegmentAlertProps) => {
  const { t } = useTranslation();

  if (showArchived) {
    return (
      <Tooltip title={t('Segment is archived and cannot be used for audience creation')}>
        <ErrorIcon fontSize="small" color="error" data-test="archived-alert" />
      </Tooltip>
    );
  }

  if (showExpired) {
    return (
      <Tooltip title={t('Segment data is expired and cannot be used for audience creation')}>
        <ErrorIcon fontSize="small" color="error" data-test="expired-icon" />
      </Tooltip>
    );
  }

  if (showExpireSoon) {
    return (
      <Tooltip title={getExpireSoonTitle(t, segmentDaysRemaining)}>
        <WarningIcon fontSize="small" color="warning" data-test="expire-soon-icon" />
      </Tooltip>
    );
  }

  return null;
};
